import { useEffect } from 'react';
import { Outlet, PathParam, useParams } from 'react-router-dom';
import { useTranslation } from 'translations/hooks';

import { useGraphqlApiHeaders } from 'business/contextProviders/useApiHeaders';
import { useAppContext } from 'business/contextProviders/useAppContext';
import Routes from 'config/routes';
import {
  Module_Enum,
  useGetRingConstructionSiteQuery,
} from 'generated/graphql';

import Page from './page';

interface Props {
  header?: React.ReactNode;
  children?: React.ReactNode;
  img?: { src: string; alt: string };
  footer?: React.ReactNode;
}

function RingComplianceConnectedPage(props: Props) {
  const {
    isConnected,
    currentConstructionSiteId,
    setCurrentConstructionSiteId,
  } = useAppContext();
  const { t } = useTranslation();
  const { ringId } =
    useParams<PathParam<Routes.QualityRingComplianceReportDetail>>();

  const graphqlHeaders = useGraphqlApiHeaders(Module_Enum.QualityControl);
  const { data } = useGetRingConstructionSiteQuery({
    variables: { ringId },
    skip: !ringId,
    context: { headers: graphqlHeaders },
  });
  const navTitle = t('module.header', { context: Module_Enum.QualityControl });

  useEffect(() => {
    if (
      data?.parameter_ring_by_pk?.constructionSiteId &&
      data.parameter_ring_by_pk.constructionSiteId !== currentConstructionSiteId
    ) {
      setCurrentConstructionSiteId(
        data.parameter_ring_by_pk.constructionSiteId,
      );
    }
  });

  return (
    <Page {...props} isConnected={isConnected} title={navTitle}>
      <Outlet />
    </Page>
  );
}

export default RingComplianceConnectedPage;
